import styled from 'styled-components';

export default {
    Modal: styled.div.attrs({ className: 'modal' })`
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100%;
        background: rgba(66, 65, 65, 0.6);
        z-index: 101;
        overflow-y: auto;
    `,
    ModalContent: styled.div.attrs({ className: 'modal-content' })`
        font-family: Noto Sans,serif;
        position: relative;
        background-color: #fff;
        z-index: 110;
        top: 108px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        min-height: 368px;
        height: auto;
        width: 92vw;
        padding: 47px 24px 20px;
        box-shadow: 0 5px 40px rgba(0, 0, 0, 0.3);
        box-sizing: border-box;
        @media (max-width: 320px) {
            width: 310px;
        }
        @media (min-width: 700px) {
            width: 540px;
        }
        @media (min-width: 1000px) {
            width: 980px;
            border-radius: 5px;
            height: 450px;
            top: 230px;
            padding: 89px 120px 30px;
        }
    `,
    ModalTitle: styled.h3.attrs({ className: 'modal-title' })`
        font-family: 'Toyota Display Bold',serif;
        font-size: 24px;
        font-weight: Bold;
        line-height: 24px;
        letter-spacing: -1.32px;
        display: block;
        padding: 0;
        margin: 0;
        text-align: left;
        @media (min-width: 1000px) {
            font-size: 35px;
            line-height: 46px;
            letter-spacing: -2.3px;
        }
    `,
    ModalTextContainer: styled.div.attrs({ className: 'modal-text-container' })`
        max-width: 839px;
        margin: 5px 0 16px;
        min-height: 82px;
        max-height: 342px;
        overflow-y: auto;
        @media (min-width: 1000px) {
            margin: 6px 0 30px;
        }
    `,
    ModalName: styled.p.attrs({ className: 'modal-name' })`
        width: 100%;
        font-size: 16px;
        color: #202020;
        text-align: left;
        font-family: Toyota Display,serif;
        line-height: 20px;
        margin-top: 14px;
        margin-bottom: 9px;
        @media(min-width: 700px) {
            margin-top: 18px;
            margin-bottom: 6px;
        }
    `,
    ModalText: styled.p.attrs({ className: 'modal-text' })`
        width: 100%;
        font-size: 16px;
        color: #202020;
        text-align: left;
        font-family: Toyota Display,serif;
        line-height: 24px;
        margin-top: 0;
        @media(min-width: 700px) {
            font-size: 16px;
            line-height: 27px;
            letter-spacing: 0.2px;
        }
    `,
    ModalPhone: styled.span`
        font-family: 'Toyota Display Bold',serif;
        font-size: 24px;
        font-weight: bold;
        line-height: 36px;
        color: #202020;
        letter-spacing: 0.25px;
        display: block;
        text-align: left;
        margin-top: 30px;
        margin-bottom: 4px;
    `,
    ModalSmallText: styled.span`
        font-family: Toyota Display,serif;
        font-size: 16px;
        line-height: 30px;
        padding-left: 0;
        color: #595D60;
        display: block;
        text-align: left;
        margin-bottom: 10px;
    `,
};
